export default {"src":"/_next/static/image/public/images/ic_product_not_bought.92c8da9de1979cff04d990475dff7142.svg","height":141,"width":132};